module.exports = __webpack_public_path__ + "media/images/client_logos/logo_ferpection_200-655d5742d96742c06c504ee05c2220fd.png";